import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from '../pages/styles.module.scss';
import { getLang } from '../../../helpers/utils';
import { IKatoItem, IStatistics } from '../../../types/kato.types';
import { useTranslation } from 'react-i18next';
import { statisticsKeys } from '../../../consts/other.conts';
import { ArrowDownIcon, PenIcon } from '../../../assets/icons';
import { oblast } from '../../../consts/kato.conts';

const baseClass = 'kato-item';
const translationKey = `admin`;

type Props = {
    item: IKatoItem;
    level: number;
    statistics: Record<string, IStatistics>;
};

const KatoItem: React.FC<Props> = ({ item, level, statistics }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [expanded, setExpanded] = useState(false);

    const label = item[`name${getLang()}`];

    const handleEdit = () => {
        navigate(`/admin/${item.kato}/general-info`, { state: { item } });
    };

    return (
        <div className={`${classes[baseClass]} ${classes[`${baseClass}--level-${level}`]} ${expanded ? classes[`${baseClass}--expanded`] : ''}`} style={{ paddingLeft: level * 20 }}>
            <div className={classes[`${baseClass}__header`]}>
                <span
                    onClick={() => setExpanded(!expanded)}
                    className={classes[`${baseClass}__name`]}
                >
                    {item.kato !== oblast.kato && !!item.children?.length && <ArrowDownIcon style={{ transform: expanded ? 'rotate(-90deg)' : 'rotate(0deg)' }} />}
                    {label}
                    <button onClick={handleEdit} className={classes[`${baseClass}__edit-btn`]}>
                        <PenIcon />
                    </button>
                </span>

                {statistics[item.kato] && (
                    <div className={classes[`${baseClass}__statistics`]}>
                        {statisticsKeys.map((key) => (
                            <div className={classes[`${baseClass}__statistics__item`]} key={key}>{t(`${translationKey}.${key}`)}: {statistics[item.kato][key]}</div>
                        ))}
                    </div>
                )}
            </div>

            {expanded && item.children && item.children?.length > 0 && (
                <div className={classes.children}>
                    {item.children.map((child: IKatoItem) => (
                        <KatoItem key={child.kato} item={child} level={level + 1} statistics={statistics} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default KatoItem;
